


























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import HolidaysOverview from "./HolidaysOverview.vue";
import HolidaysParticipants from "./HolidaysParticipants.vue";
import HolidaysRequests from "./HolidaysRequests.vue";
import HolidaysAll from "./HolidaysAll.vue";
import HolidaysPrograms from "./HolidaysPrograms.vue";
import HolidaysPayments from "./HolidaysPayments.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Holidays",
  components: {
    MainTabbar,
    HolidaysOverview,
    HolidaysParticipants,
    HolidaysRequests,
    HolidaysAll,
    HolidaysPrograms,
    HolidaysPayments,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      HolidayProgramBookingStatusNames: {
        pending: "Bestätigung benötigt",
        waitingList: "Auf Warteliste",
        booked: "Buchung ist vollständig",
        readyForPayment: "Bereit für Bezahlung",
        paymentExported: "Rechnung wurde exportiert",
        canceled: "Abgesagt, Gebühr-Export ausstehend",
        cancellationFeeExported: "Abgesagt, Gebühr wurde exportiert",
      },
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Übersicht",
          linkedComponent: "HolidaysOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
        },
        {
          title: "Teilnehmende",
          linkedComponent: "HolidaysParticipants",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
        },
        {
          title: "Anfragen",
          linkedComponent: "HolidaysRequests",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
        },
        {
          title: "Alle Plätze",
          linkedComponent: "HolidaysAll",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
        },
        {
          title: "Zahlungen",
          linkedComponent: "HolidaysPayments",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
        {
          title: "Ferienprogramme",
          linkedComponent: "HolidaysPrograms",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleHolidays),
        },
      ] as ModulesJson[];
    },
  },
});
